<section class="content tab-section d-flex flex-column">
  <div class="content-block">
    <div class="tab-content p-0 d-flex flex-column flex-grow-1">
      <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4 flex-grow-1 "
        [(selectedIndex)]="selectedTab" (selectedTabChange)="onTabChange($event)" [@.disabled]="true">
        <div [ngTemplateOutlet]="pagination" *ngIf="dataSource.data.length!=0"></div>
        <mat-tab label="Manager" class="p-24">
          <div class="d-flex justify-content-between user-b gap-3 mb-2 flex-wrap">

            <div class="search-cont gap-2 gap-sm-3 ">
              <div class="s-in form-input me-0" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
                  (input)="onSearch($event)" (keyup.enter)="onGo()" />
              </div>
              <div class="go-b me-0" (click)="onGo()">Go</div>
              <div class="s-item d-box " (click)="onFilterView()">
                <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
              </div>
            </div>

            <div class="btn-container d-flex align-items-center flex-wrap onnoard-company-modal gap-3">
              <!-- <button type="button" class="btn btn-outline-primary" (click)="openDialog()"> Open Modal </button> -->
              <button
                class="btn c-btn btn-outline-grey outline-btn no-sh-btn  d-flex align-items-center justify-content-center "
                type="submit" (click)="onDownloadSample('manager')"> <img src="assets/images/icons/sample_csv.svg"
                  class="img-fluid me-1">Sample CSV</button>
              <button
                class="btn c-btn btn-outline-grey outline-btn no-sh-btn  d-flex align-items-center justify-content-center "
                type="submit" (click)="onImportCSV('manager')"> <img src="assets/images/icons/import_csv.svg"
                  class="img-fluid me-1">Import CSV</button>
              <button
                class="btn c-btn btn-outline-grey outline-btn no-sh-btn d-flex align-items-center justify-content-center "
                type="submit" (click)="onExportCSV('manager')"> <img src="assets/images/icons/export_csv.svg"
                  class="img-fluid me-1">Export CSV</button>
              <button mat-raised-button color="primary" class="primary-btn d-box" type="submit"
                (click)="onAddSingleUser()"><i class="fas fa-plus"></i> Add Single User</button>
              <button mat-raised-button color="primary" class="primary-btn d-box " type="submit"
                (click)="onAddNewUser('manager')"><i class="fas fa-plus"></i> Add Multiple User</button>
              <button mat-raised-button color="primary" class="primary-btn d-box " type="submit"
                (click)="onAssign('manager')"><i class="	fas fa-user-plus"></i> Assign Employee</button>
            </div>
          </div>
          <app-filter *ngIf="filterShowObj.managerFilter" (childEvent)="callApi($event)"
            [fieldCol]="fieldCol"></app-filter>
          <div class="flex-grow-1 table-container">
            <table class="mt-2 mt-sm-3" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">Name</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture" iType="manager">
                    </div>
                    <div class="">
                      <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                      <div class="sub-head">{{element.email}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="phone_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"> Phone
                  Number </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.phone_number">{{ element.phone_number }}</span>
                  <span class="text-bold" *ngIf="!element.phone_number">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="date_added">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Added</th>
                <td mat-cell *matCellDef="let element"> {{element.date_added | dates : 'date_time'}} </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="action-btn" matTooltip="View" (click)="onViewManager(element)"><img
                        src="assets/images/icons/view_icon.svg" class="img-fluid" alt=""></div>
                    <div class="action-btn" (click)="onEditItem('Manager',element)" matTooltip="Edit">
                      <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-btn " matTooltip="Assigned employee list"
                      (click)="onViewAssignedEmployee(element.manager_id)">
                      <img src="assets/images/icons/assign_ic (1).svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-btn  " matTooltip="Delete"
                      (click)="onDeleteItem('delete_content','manager',element.manager_id,element)">
                      <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                    </div>

                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dataSource.data.length==0">
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
          </div>
          <div [ngTemplateOutlet]="pagination" *ngIf="dataSource.data.length!=0"></div>
        </mat-tab>
        <mat-tab label="Employee">
          <div class="d-flex justify-content-between gap-3 user-b mb-2 flex-wrap">
            <div class="search-cont gap-2 gap-sm-3">
              <div class="s-in me-0 form-input" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
                  (input)="onSearch($event)" (keyup.enter)="onGo()" />
              </div>
              <div class="go-b me-0" (click)="onGo()">Go</div>
              <div class="s-item d-box " (click)="onFilterView()">
                <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
              </div>
            </div>
            <div class="btn-container d-flex flex-wrap gap-3">
              <button
                class="btn c-btn btn-outline-grey outline-btn no-sh-btn   d-flex align-items-center justify-content-center"
                type="submit" (click)="onDownloadSample('employee_csv1')">
                   <img src="assets/images/icons/sample_csv.svg" class="img-fluid me-1">Sample CSV</button>
              <button
                class="btn c-btn btn-outline-grey outline-btn no-sh-btn  d-flex align-items-center justify-content-center"
                type="submit" (click)="onImportCSV('employee')">
                   <img src="assets/images/icons/import_csv.svg" class="img-fluid me-1">Import CSV</button>
              <button
                class="btn c-btn btn-outline-grey outline-btn no-sh-btn  d-flex align-items-center justify-content-center"
                type="submit" (click)="onExportCSV('employee')"> <img src="assets/images/icons/export_csv.svg"
                  class="img-fluid me-1">Export CSV</button>
              <button mat-raised-button color="primary" class="primary-btn" type="submit"
                (click)="onAddNewUser('employee')">
                <i class="fas fa-plus"></i> Add New User</button>
              <button mat-raised-button color="primary" class="primary-btn d-box " type="submit"
                (click)="onAssign('employee')"><i class="	fas fa-user-plus"></i> Assign Manager</button>
            </div>
          </div>
          <app-filter *ngIf="filterShowObj.empFilter" (childEvent)="callApi($event)" [fieldCol]="fieldCol"></app-filter>
          <div class="table-container flex-grow-1">
            <table class="mt-2 mt-sm-3" mat-table [dataSource]="dataSourceEmp" #sortEmp="matSort" matSort
              (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Name </th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture">
                    </div>
                    <div class="">
                      <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                      <div class="sub-head">{{element.email}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="applied_time">
                <th mat-header-cell *matHeaderCellDef> Applied Time </th>
                <td mat-cell *matCellDef="let element"> {{element.create_time | dates}} </td>
              </ng-container>
              <ng-container matColumnDef="signed_up">
                <th mat-header-cell *matHeaderCellDef> Signed Up Date </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.created_on!='-'"> {{formatTimestamp(element.created_on) | dates}} </span>
                  <span class="pending badge-c d-box" *ngIf="element.created_on=='-'">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="phone_number">
                <th mat-header-cell *matHeaderCellDef> Phone Number </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.phone_number">{{ element.phone_number }}</span>
                  <span class="text-bold" *ngIf="!element.phone_number">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status</th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-bold st-box  d-flex ">
                    <span class="active badge-c d-box" *ngIf="element.is_status==1">{{"Accepted"|translate}}</span>
                    <span class="pending badge-c d-box" *ngIf="element.is_status==2">{{"Pending"|translate}}</span>
                    <span class="un-attend   badge-c d-box" *ngIf="element.is_status==0">{{"Rejected"|translate}}</span>
                  </div>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="action-btn" matTooltip="View" (click)="onViewEmployee(element.employee_id)"
                      *ngIf="element.is_status==1">
                      <img src="assets/images/icons/view_icon.svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-btn" matTooltip="Edit" (click)="onEditItem('Employee',element)"
                      *ngIf="element.is_status==1">
                      <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-icon me-2" matTooltip="Delete"
                      (click)="onDeleteItem('delete_content','employee',element.employee_id,element)">
                      <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsEmp"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsEmp;"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dataSourceEmp.data.length==0">
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
          </div>
          <div [ngTemplateOutlet]="pagination" *ngIf="dataSourceEmp.data.length!=0"></div>
        </mat-tab>
        <mat-tab label="Recruiter" *ngIf="userInfo.u_typ==0">
          <div class="o-div d-flex justify-content-between mb-2 gap-3 flex-wrap">


            <!-- <div class="form-input ">
              <input type="text" class="form-control" placeholder="{{'Search...'}}" (keyup)="doFilter($event)">
              <mat-icon class="input-icon">search</mat-icon>
            </div> -->
            <div class="search-cont gap-sm-3 ">
              <div class="s-in form-input me-0" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="searchInput"
                  (input)="onSearch($event)" (keyup.enter)="onGo()" />
              </div>
            </div>

            <div class="btn-container d-flex justify-content-between gap-3 flex-wrap">
              <button type="button" class="btn btn-outline-primary  d-flex align-items-center"
                (click)="onExportCSV('admin')">
                <div class="me-2"> <img src="assets/images/icons/csv.png" alt="" class="img-fluid"></div> Export CSV
              </button>
              <button mat-raised-button color="primary" class="primary-btn btn me-auto" type="submit"
                (click)="onHireRecruiter()">
                <i class="fas fa-user-tie fa-beat"></i> {{"Hire Recruiter"|translate}}</button>
            </div>



          </div>

          <div class="rec-table table-container flex-grow-1 ">
            <table class="mt-2 mt-sm-3" mat-table [dataSource]="dataSourceRec" matSort #sortRec="matSort"
              (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Name</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture" iType="company_logo">
                    </div>
                    <div class="">
                      <div class="main-head">{{element.company_name }} </div>
                      <div class="sub-head">{{element.email}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Recruiter Approval </th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-bold st-box  d-flex ">
                    <span class="active badge-c d-box" *ngIf="element.app==1">{{"Accepted"|translate}}</span>
                    <span class="pending badge-c d-box" *ngIf="element.app==2">{{"Pending"|translate}}</span>
                    <span class="un-attend   badge-c d-box" *ngIf="element.app==0">{{"Rejected"|translate}}</span>
                  </div>
              </ng-container>
              <ng-container matColumnDef="contract">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Contract
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    class="btn c-btn btn-outline-grey outline-btn no-sh-btn d-flex align-items-center justify-content-center"
                    type="submit" *ngIf="!element.download && element.doc_name"
                    (click)="onSignContract(element.doc_id)">
                    <i class="fas fa-file-signature me-1 sign"></i>Sign Contract</button>
                  <button mat-flat-button color="warn" class=" gradient-green-btn" type="submit"
                    *ngIf="element.download" (click)="onDownload(element.download)">
                    <img src="assets/images/icons/download.png" class="img-fluid me-1"> Download</button>

                  <span class="text-bold" *ngIf="!element.doc_name && !element.download">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex" (click)="onDeleteItem('delete_content','recruiter',element.id,element)">
                    <div class="action-icon me-2 ">
                      <img src="assets/images/icons/delete.png" class="img-fluid" alt="">
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsRec"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsRec;"></tr>
            </table>
          </div>
          <div class="mat-table__message" *ngIf="dataSourceRec.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
          <div [ngTemplateOutlet]="pagination" *ngIf="dataSourceRec.data.length!=0"></div>
        </mat-tab>
        <mat-tab label="Company" *ngIf="userInfo.u_typ==1">
          <div class="d-flex justify-content-between mb-3 gap-3 flex-wrap">
            <div class="search-cont gap-sm-3 ">
              <div class="s-in form-input me-0" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="searchInput"
                  (input)="onSearch($event)" (keyup.enter)="onGo()" />
              </div>
            </div>
            <div class="btn-container gap-3 d-flex justify-content-between flex-wrap">
              <button
                class="upload-contract btn c-btn btn-outline-grey outline-btn no-sh-btn mb-md-0  d-flex align-items-center justify-content-center"
                type="submit" (click)="onUploadContract()">
                <i class="fas fa-file-signature me-1 sign"></i>Upload Contract</button>
              <button
                class="copy-sign-up btn c-btn btn-outline-grey outline-btn no-sh-btn mb-md-0  d-flex p-link align-items-center justify-content-center"
                type="submit" (click)="onShareSignUpLink()" (click)="tooltip.show()">
                <div class="tooltip p-0" [ngStyle]="{'visibility': isContentCopied ? 'p-tool' : 'hidden'}"
                  #tooltip="matTooltip" matTooltip="Link Copied !!" delay="1000"></div>
                <i class="material-icons me-1 sign">link</i>Copy Sign-Up Link
              </button>
              <button mat-raised-button color="primary" class="primary-btn d-box  mb-sm-2 mb-md-0 " type="submit"
                (click)="onAddNewUser('company')"><i class="fas fa-plus"></i> Add New User</button>
            </div>
          </div>
          <div class="flex-grow-1 rec-table table-container">
            <table class="mt-4 " mat-table [dataSource]="dataSourceComp" matSort #sortRec="matSort"
              (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Name</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="profile-img me-2" [appBackgroundImg]="element.company_logo" iType="company_logo">
                    </div>
                    <div class="">
                      <div class="main-head">{{element.company_name }} </div>
                      <div class="sub-head">{{element.email}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Status
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-bold st-box  d-flex ">
                    <span class="active badge-c d-box" *ngIf="element.app==1">{{"Accepted"|translate}}</span>
                    <span class="pending badge-c d-box" *ngIf="element.app==2">{{"Pending"|translate}}</span>
                    <span class="un-attend   badge-c d-box" *ngIf="element.app==0">{{"Rejected"|translate}}</span>
                    <i class="material-icons cursor-pointer more-ic" [matMenuTriggerFor]="menu">more_vert</i>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item color="primary" (click)="acceptReject('accept',1,element)">
                        <mat-icon class="kt-margin-r-0">thumb_up</mat-icon>
                        <span>Accept</span>
                      </button>
                      <button mat-menu-item color="primary" (click)="acceptReject('reject',0,element)">
                        <mat-icon class="kt-margin-r-0">thumb_down</mat-icon>
                        <span>Reject</span>
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="phone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Phone Number
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="steel-blue">9999999999</div>
                  </td>
                </ng-container> -->
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Registration
                  Time</th>
                <td mat-cell *matCellDef="let element">
                  <div class="steel-blue">{{element.c_at | dates}}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="contract">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"> Contract
                </th>
                <td mat-cell *matCellDef="let element">

                  <button mat-flat-button color="warn" class=" gradient-green-btn" type="submit"
                    *ngIf="element.doc_name" (click)="onDownload(element.doc_name)">
                    <img src="assets/images/icons/download.png" class="img-fluid me-1"> Download</button>
                  <span class="text-bold" *ngIf="!element.doc_name">-</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex">
                    <div class="action-btn" (click)="onViewCompany(element,'setting')" *ngIf="element.app==1">
                      <img src="assets/images/icons/view_icon.svg" class="img-fluid" alt="">
                    </div>
                    <div class="action-btn" matTooltip="View Company Dashboard"
                      (click)="onViewCompany(element,'dashboard')" *ngIf="element.app==1">
                      <img src="assets/images/sidebar/user_management_ic.svg" class="img-fluid" alt="">
                    </div>
                    <div class="d-flex" (click)="onDeleteItem('delete_content','company',element.id ,element)">
                      <div class="action-icon me-2 ">
                        <img src="assets/images/icons/delete.png" class="img-fluid" alt="">
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsComp"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsComp;"></tr>
            </table>
            <div class="mat-table__message" *ngIf="dataSourceComp.data.length==0">
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
            </div>
          </div>
          <div [ngTemplateOutlet]="pagination" *ngIf="dataSourceComp.data.length!=0"></div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</section>
<ng-template #pagination>
  <div class="pagination-cont">
    <div class="show-item"> {{"COMMON.SIP" | translate}}
      <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
        <option [value]="item" *ngFor="let item of pageSizeOptions"> {{ item }}</option>
      </select>
    </div>
    <div class="page-c">
      <ngb-pagination [collectionSize]="countPagination" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
        [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
    </div>
  </div>
</ng-template>